import { useQuery } from "@tanstack/react-query";
import { rankingsApi } from "@/api/rankings.api";
import { queryKeys } from "@/utils/queryKeys";

/**
 * The backend only supports a `limit` (no offset/page), so we fetch the top
 * `limit` rows once and paginate client-side via `select` — mirrors the
 * `{ items, total }` shape of the server-paginated list hooks.
 */
export function useDriverRankings(page: number, pageSize = 20, limit = 1000) {
  return useQuery({
    queryKey: queryKeys.rankings.list(limit),
    queryFn: () => rankingsApi.list(limit),
    select: (data) => ({
      items: data.slice((page - 1) * pageSize, page * pageSize),
      total: data.length,
      computedAt: data[0]?.computedAt,
    }),
  });
}
